import { render, staticRenderFns } from "./AppBreadcrumb.vue?vue&type=template&id=52d6db1c&scoped=true&"
import script from "./AppBreadcrumb.vue?vue&type=script&lang=js&"
export * from "./AppBreadcrumb.vue?vue&type=script&lang=js&"
import style0 from "./AppBreadcrumb.vue?vue&type=style&index=0&id=52d6db1c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d6db1c",
  null
  
)

export default component.exports